import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { Button } from '../components/Button';
import { KPICard } from '../components/KPICard';
import { ArrowLeft, Trophy, Activity, Target, ArrowRight, AlertTriangle, Award, Users } from 'lucide-react';
import { getBinda, getRegions, getUnits, getPersonnelByBinda, scoreColor, KPI_FORMULA } from '../data/kpiIntelligence';
export default function KPIBindaDetail() {
  const {
    kode
  } = useParams();
  const navigate = useNavigate();
  const binda = getBinda(kode || '');
  if (!binda) {
    return <div className="flex flex-col items-center justify-center h-full space-y-4" data-id="element-1536">
        <h2 className="text-xl font-mono text-muted-foreground" data-id="element-1537">
          Data BINDA tidak ditemukan
        </h2>
        <Button onClick={() => navigate('/kpi')} variant="outline" data-id="element-1538">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-1539" /> Kembali ke Dashboard KPI
        </Button>
      </div>;
  }
  const regions = getRegions(binda.kode);
  const units = getUnits(binda.kode);
  const personnel = getPersonnelByBinda(binda.kode);
  const topPerformer = personnel[0];
  const bottomPerformer = personnel[personnel.length - 1];
  return <div className="space-y-6 animate-in fade-in duration-500 max-w-7xl mx-auto pb-12" data-id="element-1540">
      <div className="flex items-center gap-4 border-b border-border/50 pb-4" data-id="element-1541">
        <Button variant="ghost" size="icon" onClick={() => navigate('/kpi')} className="hover:bg-primary/20 hover:text-primary" data-id="element-1542">
          <ArrowLeft className="w-5 h-5" data-id="element-1543" />
        </Button>
        <div data-id="element-1544">
          <h1 className="text-2xl font-heading font-bold tracking-tight text-foreground flex items-center gap-3" data-id="element-1545">
            {binda.binda.toUpperCase()}
            <span className="text-sm font-mono text-primary bg-primary/10 px-2 py-1 rounded border border-primary/30" data-id="element-1546">
              {binda.kode}
            </span>
          </h1>
          <p className="text-muted-foreground font-mono text-xs mt-1 uppercase tracking-widest" data-id="element-1547">
            Level 2: Kinerja BINDA // Peringkat Nasional: #{binda.rank}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1548">
        <KPICard title="Skor KPI BINDA" value={binda.score} icon={Target} colorVar={scoreColor(binda.score)} trend={{
        value: `${binda.trend >= 0 ? '+' : ''}${binda.trend}%`,
        label: 'vs Bulan Lalu',
        isPositive: binda.trend >= 0
      }} data-id="element-1549" />
        <KPICard title="Grade" value={`Grade ${binda.grade}`} icon={Trophy} colorVar={scoreColor(binda.score)} progress={{
        value: binda.score,
        label: 'Pencapaian',
        target: '100'
      }} data-id="element-1550" />
        <KPICard title="Total Laporan" value={binda.laporanTotal.toLocaleString('id-ID')} icon={Activity} colorVar="var(--status-info)" data-id="element-1551" />
        <KPICard title="Rasio Validitas" value={`${binda.rasioValid}%`} icon={Award} colorVar="var(--status-standby)" data-id="element-1552" />
      </div>

      {/* Komponen KPI */}
      <Card className="glass-panel border-border/50" data-id="element-1553">
        <CardHeader className="border-b border-border/50 bg-card/50" data-id="element-1554">
          <CardTitle className="text-sm font-mono uppercase tracking-widest" data-id="element-1555">
            Komponen Penilaian KPI
          </CardTitle>
        </CardHeader>
        <CardContent className="p-4" data-id="element-1556">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4" data-id="element-1557">
            {KPI_FORMULA.map(f => {
            const val = binda.components[f.key];
            return <div key={f.key} className="p-3 rounded border border-border/30 bg-background/30" data-id="element-1558">
                  <div className="text-[10px] font-mono text-muted-foreground uppercase mb-1" data-id="element-1559">
                    {f.label} ({f.bobot}%)
                  </div>
                  <div className="text-2xl font-bold font-mono" style={{
                color: scoreColor(val)
              }} data-id="element-1560">
                    {val}
                  </div>
                </div>;
          })}
          </div>
        </CardContent>
      </Card>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1561">
        {/* Ranking Kabupaten/Kota */}
        <Card className="glass-panel border-border/50" data-id="element-1562">
          <CardHeader className="border-b border-border/50 bg-card/50" data-id="element-1563">
            <CardTitle className="text-sm font-mono uppercase tracking-widest" data-id="element-1564">
              Ranking Kabupaten/Kota
            </CardTitle>
          </CardHeader>
          <CardContent className="p-0" data-id="element-1565">
            <div className="divide-y divide-border/30 max-h-[300px] overflow-y-auto" data-id="element-1566">
              {regions.map((r, i) => <div key={r.id} className="flex items-center justify-between p-3 hover:bg-white/5 transition-colors" data-id="element-1567">
                  <div className="flex items-center gap-3" data-id="element-1568">
                    <span className="text-muted-foreground font-mono w-4 text-right" data-id="element-1569">
                      {i + 1}
                    </span>
                    <div data-id="element-1570">
                      <div className="font-bold text-sm" data-id="element-1571">{r.nama}</div>
                      <div className="text-[10px] font-mono text-muted-foreground" data-id="element-1572">
                        {r.laporan} Laporan
                      </div>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-1573">
                    <div className="font-mono font-bold" style={{
                  color: scoreColor(r.score)
                }} data-id="element-1574">
                      {r.score}
                    </div>
                    <div className={`text-[10px] font-mono ${r.trend >= 0 ? 'text-green-400' : 'text-red-400'}`} data-id="element-1575">
                      {r.trend >= 0 ? '+' : ''}
                      {r.trend}%
                    </div>
                  </div>
                </div>)}
            </div>
          </CardContent>
        </Card>

        {/* Ranking Unit */}
        <Card className="glass-panel border-border/50" data-id="element-1576">
          <CardHeader className="border-b border-border/50 bg-card/50" data-id="element-1577">
            <CardTitle className="text-sm font-mono uppercase tracking-widest" data-id="element-1578">
              Ranking Unit
            </CardTitle>
          </CardHeader>
          <CardContent className="p-0" data-id="element-1579">
            <div className="divide-y divide-border/30 max-h-[300px] overflow-y-auto" data-id="element-1580">
              {units.map((u, i) => <div key={u.id} className="flex items-center justify-between p-3 hover:bg-white/5 cursor-pointer transition-colors" onClick={() => navigate(`/kpi/unit/${binda.kode}/${u.id}`)} data-id="element-1581">
                  <div className="flex items-center gap-3" data-id="element-1582">
                    <span className="text-muted-foreground font-mono w-4 text-right" data-id="element-1583">
                      {i + 1}
                    </span>
                    <div data-id="element-1584">
                      <div className="font-bold text-sm" data-id="element-1585">{u.nama}</div>
                      <div className="text-[10px] font-mono text-muted-foreground" data-id="element-1586">
                        {u.anggota} Personel
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-4" data-id="element-1587">
                    <div className="text-right" data-id="element-1588">
                      <div className="font-mono font-bold" style={{
                    color: scoreColor(u.score)
                  }} data-id="element-1589">
                        {u.score}
                      </div>
                      <div className={`text-[10px] font-mono ${u.trend >= 0 ? 'text-green-400' : 'text-red-400'}`} data-id="element-1590">
                        {u.trend >= 0 ? '+' : ''}
                        {u.trend}%
                      </div>
                    </div>
                    <ArrowRight className="w-4 h-4 text-muted-foreground" data-id="element-1591" />
                  </div>
                </div>)}
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Top / Bottom Personel */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1592">
        {topPerformer && <Card className="glass-panel border-primary/30" data-id="element-1593">
            <CardHeader className="border-b border-primary/30 bg-primary/10" data-id="element-1594">
              <CardTitle className="text-sm font-mono uppercase tracking-widest flex items-center gap-2 text-primary" data-id="element-1595">
                <Trophy className="w-4 h-4" data-id="element-1596" /> Top Performer
              </CardTitle>
            </CardHeader>
            <CardContent className="p-4 flex items-center gap-4" data-id="element-1597">
              <img src={topPerformer.foto} alt={topPerformer.nama} className="w-16 h-16 rounded-full border-2 border-primary" data-id="element-1598" />
              <div className="flex-1" data-id="element-1599">
                <h3 className="font-bold text-lg" data-id="element-1600">{topPerformer.nama}</h3>
                <p className="text-xs text-muted-foreground font-mono" data-id="element-1601">
                  {topPerformer.pangkat} //{' '}
                  {units.find(u => u.id === topPerformer.unitId)?.nama}
                  // {units.find(u => u.id === topPerformer.unitId)?.nama}
                </p>
              </div>
              <div className="text-right" data-id="element-1602">
                <div className="text-3xl font-bold font-mono text-primary" data-id="element-1603">
                  {topPerformer.score}
                </div>
                <Button size="sm" variant="outline" className="mt-2 h-7 text-[10px] font-mono" onClick={() => navigate(`/kpi/personnel/${topPerformer.id}`)} data-id="element-1604">
                  Lihat Detail
                </Button>
              </div>
            </CardContent>
          </Card>}

        {bottomPerformer && <Card className="glass-panel border-destructive/30" data-id="element-1605">
            <CardHeader className="border-b border-destructive/30 bg-destructive/10" data-id="element-1606">
              <CardTitle className="text-sm font-mono uppercase tracking-widest flex items-center gap-2 text-destructive" data-id="element-1607">
                <AlertTriangle className="w-4 h-4" data-id="element-1608" /> Need Improvement
              </CardTitle>
            </CardHeader>
            <CardContent className="p-4 flex items-center gap-4" data-id="element-1609">
              <img src={bottomPerformer.foto} alt={bottomPerformer.nama} className="w-16 h-16 rounded-full border-2 border-destructive grayscale" data-id="element-1610" />
              <div className="flex-1" data-id="element-1611">
                <h3 className="font-bold text-lg" data-id="element-1612">{bottomPerformer.nama}</h3>
                <p className="text-xs text-muted-foreground font-mono" data-id="element-1613">
                  {bottomPerformer.pangkat} //{' '}
                  {units.find(u => u.id === bottomPerformer.unitId)?.nama}
                  // {units.find(u => u.id === bottomPerformer.unitId)?.nama}
                </p>
              </div>
              <div className="text-right" data-id="element-1614">
                <div className="text-3xl font-bold font-mono text-destructive" data-id="element-1615">
                  {bottomPerformer.score}
                </div>
                <Button size="sm" variant="outline" className="mt-2 h-7 text-[10px] font-mono border-destructive/50 text-destructive hover:bg-destructive/10" onClick={() => navigate(`/kpi/personnel/${bottomPerformer.id}`)} data-id="element-1616">
                  Lihat Detail
                </Button>
              </div>
            </CardContent>
          </Card>}
      </div>
    </div>;
}